import React from 'react';
import {
  GridToolbarContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { color } from 'd3';
import { t } from 'i18next';
import PropTypes from 'prop-types';

const CustomToolbar = ({ placeholder }) => {
  return (
    <GridToolbarContainer
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 1,
        px: 1,
      }}
    >
      {/* ✅ SAME FILTER AS showToolbar */}
      <GridToolbarFilterButton
        slotProps={{
          button: {
            sx: {
              minWidth: 'auto',
              px: 0.5,

              // ✅ THIS is the real fix
              '& .MuiButton-startIcon': {
                margin: 0,
              },

              // ✅ hide text using overflow technique
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textIndent: '-9999px',
              '& .MuiSvgIcon-root': {
                fontSize: 22,
                color: (theme) => (theme.palette.mode === 'dark' ? 'white' : '#707070'),
              },

              // keep icon visible
              //   display: 'inline-flex',
              //   alignItems: 'center',
              //   justifyContent: 'center',
            },
          },
        }}
      />

      {/* ✅ SAME SEARCH AS showToolbar (but customized) */}
      <GridToolbarQuickFilter placeholder={placeholder} debounceMs={300} />
    </GridToolbarContainer>
  );
};

CustomToolbar.propTypes = {
  placeholder: PropTypes.string.isRequired,
};
export default CustomToolbar;
